var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.836 18.6409L22.1993 25.1069C22.0727 25.2523 21.8893 25.3356 21.6967 25.3356H17.58C17.4207 25.3356 17.2667 25.3923 17.146 25.4963L12.854 29.1756C12.7333 29.2789 12.5793 29.3356 12.42 29.3356H11.3333C10.9653 29.3356 10.6667 29.0369 10.6667 28.6689V26.0023C10.6667 25.6343 10.368 25.3356 10 25.3356H4.66667C4.29867 25.3356 4 25.0369 4 24.6689V10.6309C4 10.5269 4.024 10.4249 4.07067 10.3323L6.72467 5.03695C6.838 4.81161 7.06867 4.66895 7.32067 4.66895H27.3333C27.7013 4.66895 28 4.96761 28 5.33561V18.2029C28 18.3643 27.942 18.5196 27.836 18.6409Z",
    fill: "#8343C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17.5816C24.8887 18.8329 23.778 20.0843 22.6667 21.3356C21.1113 21.3356 19.5553 21.3356 18 21.3356C16.4447 22.6689 14.8887 24.0023 13.3333 25.3356C13.3333 24.0023 13.3333 22.6689 13.3333 21.3356C11.5553 21.3303 9.778 21.3249 8 21.3196C8 16.4356 8 11.5523 8 6.66895C14 6.66895 20 6.66895 26 6.66895C26 10.3063 26 13.9436 26 17.5816Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6689H14V17.3356H16V10.6689Z",
    fill: "#8343C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.6689H20V17.3356H22V10.6689Z",
    fill: "#8343C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.bb6c9cc481d5529ad0dc55274596b9cc.svg";
export { ForwardRef as ReactComponent };